import { render, staticRenderFns } from "./exemption.vue?vue&type=template&id=2cfe62ba&scoped=true"
import script from "./exemption.vue?vue&type=script&lang=js"
export * from "./exemption.vue?vue&type=script&lang=js"
import style0 from "./exemption.vue?vue&type=style&index=0&id=2cfe62ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfe62ba",
  null
  
)

export default component.exports